(() => {
  const showroom = document.querySelector('[data-season-showroom]');
  const collection = document.querySelector('[data-section-type="collection-template"]');

  if (!showroom || !collection) return;

  const typeRules = [
    { key: 'all-mountain', tag: 'all-mountainskidor', label: 'All Mountain', order: 10 },
    { key: 'offpist', tag: 'offpistskidor', label: 'Offpist', order: 30 },
    { key: 'pist', tag: 'pistskidor', label: 'Pist', order: 20 },
    { key: 'twintip', tag: 'twintipskidor', label: 'Twintip', order: 40 },
    { key: 'topptur', tag: 'topptursskidor', label: 'Topptur', order: 50 },
    { key: 'dam', tag: 'skidor-dam', label: 'Dam', order: 60 },
    { key: 'barn-junior', tag: 'skidor-barn', label: 'Barn & junior', order: 70 }
  ];

  const loadStatus = showroom.querySelector('[data-showroom-load-status]');
  const sourceTypeFilter = showroom.querySelector('.season-showroom__type-filter');
  const sourceTypeList = showroom.querySelector('.season-showroom__types');
  const productContainer = collection.querySelector('[data-collection-products]');
  let activeType = 'all';
  let collectionComplete = false;
  let requestGeneration = 0;
  let activeController;
  let productObserver;
  let scheduled = false;
  let stickyScheduled = false;

  const stickyBar = document.createElement('div');
  stickyBar.className = 'season-showroom__sticky-types';
  stickyBar.dataset.showroomStickyTypes = '';
  stickyBar.hidden = true;
  stickyBar.setAttribute('aria-hidden', 'true');

  const stickyInner = document.createElement('div');
  stickyInner.className = 'wrapper--full-padded season-showroom__sticky-inner';

  if (sourceTypeList) {
    const stickyTypeList = sourceTypeList.cloneNode(true);
    stickyTypeList.classList.add('season-showroom__types--sticky');
    stickyTypeList.setAttribute('aria-label', 'Skidtyper, snabbval');
    stickyInner.append(stickyTypeList);
    stickyBar.append(stickyInner);
    document.body.append(stickyBar);
  }

  const typeFilters = [
    ...showroom.querySelectorAll('[data-showroom-type-filter]'),
    ...stickyBar.querySelectorAll('[data-showroom-type-filter]')
  ];

  const productCount = () => {
    const text = collection.querySelector('[data-products-count]')?.textContent || '';
    const normalized = text.replace(/\s/g, '');
    return Number(normalized.match(/\d+/)?.[0] || 0);
  };

  const setStatus = (state, text) => {
    if (!loadStatus) return;
    loadStatus.dataset.state = state;
    loadStatus.textContent = text;
  };

  const stickyOffset = () => {
    const hasStickyHeader = document.querySelector('[data-site-header][data-position="fixed"]');
    const headerIsVisible = document.body.classList.contains('has-scrolled') &&
      !document.body.classList.contains('hide-header');
    if (!hasStickyHeader || !headerIsVisible) return 0;

    return Number.parseFloat(
      window.getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')
    ) || 0;
  };

  const updateStickyVisibility = () => {
    stickyScheduled = false;
    if (!sourceTypeFilter || !stickyBar.childElementCount) return;

    const offset = stickyOffset();
    stickyBar.style.setProperty('--showroom-sticky-top', `${offset}px`);
    const sourceBottom = sourceTypeFilter.getBoundingClientRect().bottom;
    const collectionBottom = collection.getBoundingClientRect().bottom;
    const barHeight = stickyBar.hidden ? 44 : stickyBar.offsetHeight;
    const shouldShow = sourceBottom <= offset && collectionBottom > offset + barHeight;

    if (stickyBar.hidden === !shouldShow) return;
    stickyBar.hidden = !shouldShow;
    stickyBar.setAttribute('aria-hidden', String(!shouldShow));
  };

  const scheduleStickyUpdate = () => {
    if (stickyScheduled) return;
    stickyScheduled = true;
    window.requestAnimationFrame(updateStickyVisibility);
  };

  const inferType = (card) => {
    const tags = (card.dataset.productTags || '').toLocaleLowerCase('sv');
    return typeRules.find((rule) => tags.includes(rule.tag)) || {
      key: 'other',
      label: 'Övriga skidor',
      order: 999
    };
  };

  const removeHeadings = (grid) => {
    grid.querySelectorAll('[data-showroom-heading]').forEach((heading) => heading.remove());
  };

  const groupProducts = (grid) => {
    removeHeadings(grid);

    const cards = [...grid.querySelectorAll(':scope > [data-product-item]')];
    if (!cards.length) return { total: 0, visible: 0 };

    const products = cards.map((card) => {
      const vendor = card.querySelector('.product-cutline')?.textContent.trim() || 'Övriga varumärken';
      const title = card.querySelector('.product-grid-item__title')?.textContent.trim() || '';
      const skiType = inferType(card);
      return { card, vendor, title, skiType };
    }).sort((a, b) =>
      a.vendor.localeCompare(b.vendor, 'sv') ||
      a.skiType.order - b.skiType.order ||
      a.title.localeCompare(b.title, 'sv')
    );

    let previousVendor = '';
    let previousType = '';
    let visibleCount = 0;

    products.forEach((product) => {
      const isVisible = activeType === 'all' || product.skiType.key === activeType;
      product.card.hidden = !isVisible;
      product.card.classList.toggle('showroom-product-hidden', !isVisible);

      if (!isVisible) {
        grid.append(product.card);
        return;
      }

      visibleCount += 1;

      if (product.vendor !== previousVendor) {
        const heading = document.createElement('h2');
        heading.className = 'showroom-group-heading';
        heading.dataset.showroomHeading = '';
        heading.textContent = product.vendor;
        grid.append(heading);
        previousVendor = product.vendor;
        previousType = '';
      }

      if (product.skiType.label !== previousType) {
        const heading = document.createElement('h3');
        heading.className = 'showroom-type-heading';
        heading.dataset.showroomHeading = '';
        heading.textContent = product.skiType.label;
        grid.append(heading);
        previousType = product.skiType.label;
      }

      grid.append(product.card);
    });

    return { total: products.length, visible: visibleCount };
  };

  const setCompleteStatus = (counts) => {
    if (activeType === 'all') {
      setStatus('complete', `Visar alla ${counts.total} produkter.`);
      return;
    }

    const label = typeRules.find((rule) => rule.key === activeType)?.label || 'vald skidtyp';
    setStatus('complete', `Visar ${counts.visible} produkter i ${label}.`);
  };

  const completeStatus = (grid) => {
    setCompleteStatus(groupProducts(grid));
  };

  const paginationPages = (container) => {
    const pages = [...container.querySelectorAll('.pagination a[href*="page="]')]
      .map((link) => Number(new URL(link.href, window.location.origin).searchParams.get('page')))
      .filter((page) => Number.isInteger(page) && page > 0);

    return Math.max(1, ...pages);
  };

  const sectionPageUrl = (page) => {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', collection.dataset.sectionId);
    return url;
  };

  const fetchPageCards = async (page, signal) => {
    const response = await fetch(sectionPageUrl(page), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal
    });

    if (!response.ok) throw new Error(`Page ${page} returned ${response.status}`);

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const cards = [...documentFragment.querySelectorAll('[data-collection-products] > .grid > [data-product-item]')];

    if (!cards.length) throw new Error(`Page ${page} did not contain products`);
    return cards;
  };

  const fetchAllPages = async (pages, signal) => {
    const results = new Array(pages.length);
    let nextIndex = 0;

    const worker = async () => {
      while (nextIndex < pages.length) {
        const index = nextIndex;
        nextIndex += 1;
        results[index] = await fetchPageCards(pages[index], signal);
      }
    };

    const workerCount = Math.min(2, pages.length);
    await Promise.all(Array.from({ length: workerCount }, worker));
    return results.flat();
  };

  const appendUniqueCards = (grid, cards) => {
    const existingIds = new Set(
      [...grid.querySelectorAll(':scope > [data-product-item]')]
        .map((card) => card.dataset.productId)
        .filter(Boolean)
    );

    cards.forEach((card) => {
      const productId = card.dataset.productId;
      if (productId && existingIds.has(productId)) return;
      if (productId) existingIds.add(productId);
      card.classList.add('loaded-item');
      grid.append(card);
    });
  };

  const enhanceCollection = async () => {
    collectionComplete = false;
    const generation = ++requestGeneration;
    activeController?.abort();
    activeController = new AbortController();

    const container = collection.querySelector('[data-collection-products]');
    const grid = container?.querySelector(':scope > .grid');
    if (!container || !grid) return;

    const expectedCount = productCount();
    const currentPage = Number(new URL(window.location.href).searchParams.get('page') || 1);
    const totalPages = paginationPages(container);
    const pagesToFetch = Array.from({ length: totalPages }, (_, index) => index + 1)
      .filter((page) => page !== currentPage);

    groupProducts(grid);

    if (!pagesToFetch.length) {
      collectionComplete = true;
      completeStatus(grid);
      collection.removeAttribute('aria-busy');
      return;
    }

    setStatus('loading', `Laddar hela urvalet — ${expectedCount} produkter…`);
    collection.setAttribute('aria-busy', 'true');

    try {
      const cards = await fetchAllPages(pagesToFetch, activeController.signal);
      if (generation !== requestGeneration || !grid.isConnected) return;

      const firstVisibleCard = [...grid.querySelectorAll(':scope > [data-product-item]')]
        .find((card) => card.getBoundingClientRect().bottom > 0);
      const anchorTop = firstVisibleCard?.getBoundingClientRect().top;

      removeHeadings(grid);
      appendUniqueCards(grid, cards);
      groupProducts(grid);

      const renderedCount = grid.querySelectorAll(':scope > [data-product-item]').length;
      if (renderedCount >= expectedCount) {
        productObserver?.disconnect();
        container.querySelector('.pagination')?.remove();
        productObserver?.observe(productContainer, { childList: true });
        collectionComplete = true;
        completeStatus(grid);
      } else {
        setStatus('error', `Visar ${renderedCount} av ${expectedCount} produkter. Använd sidnavigeringen för resten.`);
      }

      if (firstVisibleCard && anchorTop !== undefined && grid.getBoundingClientRect().top < 0) {
        window.scrollBy(0, firstVisibleCard.getBoundingClientRect().top - anchorTop);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        setStatus('error', 'Hela urvalet kunde inte läsas in. Använd sidnavigeringen för att se resterande produkter.');
      }
    } finally {
      if (generation === requestGeneration) collection.removeAttribute('aria-busy');
    }
  };

  const scheduleEnhancement = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      enhanceCollection();
    });
  };

  if (productContainer) {
    productObserver = new MutationObserver(scheduleEnhancement);
    productObserver.observe(productContainer, { childList: true });
  }

  window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
  window.addEventListener('resize', scheduleStickyUpdate);
  document.addEventListener('theme:resize', scheduleStickyUpdate);

  typeFilters.forEach((button) => {
    button.addEventListener('click', () => {
      activeType = button.dataset.showroomTypeFilter || 'all';
      const clickedStickyFilter = stickyBar.contains(button);
      const collectionTop = window.scrollY + collection.getBoundingClientRect().top;

      typeFilters.forEach((filter) => {
        const isActive = filter.dataset.showroomTypeFilter === activeType;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', String(isActive));
      });

      const grid = collection.querySelector('[data-collection-products] > .grid');
      if (!grid) return;

      const counts = groupProducts(grid);
      if (collectionComplete) setCompleteStatus(counts);

      if (clickedStickyFilter) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({
          top: Math.max(0, collectionTop - stickyOffset() - stickyBar.offsetHeight),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      scheduleStickyUpdate();
    });
  });

  enhanceCollection();
  scheduleStickyUpdate();
})();
